import type { ObraLineMarkProps } from "./types-gantt-obra-line";
import { useObraLineMark } from "./use-gantt-obra-line";
import { ObraLineMarkView } from "./view-gantt-obra-line";

export function ObraLineMark(props: ObraLineMarkProps) {
  const vm = useObraLineMark(props);

  return <ObraLineMarkView {...vm} />;
}

export type * from "./types-gantt-obra-line";
